(function () {
  if (window.__cnPreorderInit) return;
  window.__cnPreorderInit = true;

  var cfg = null;
  function config() {
    if (cfg) return cfg;
    var el = document.querySelector('script[type="application/json"][data-cn-preorder]');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = null; }
    return cfg;
  }

  function setHidden(form, name, value) {
    var input = form.querySelector('input[data-cn-preorder-prop="' + name + '"]');
    if (value == null) { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-cn-preorder-prop', name);
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }

  function applyForm(pf, data) {
    var form = pf.querySelector('form[data-type="add-to-cart-form"]') || pf.querySelector('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var st = idInput ? data.variants[idInput.value] : null;
    var btn = form.querySelector('.product-form__submit');
    var label = btn && btn.querySelector('span');
    var wrap = form.querySelector('.product-form__buttons');
    var note = form.querySelector('.cn-preorder-note');

    if (st && btn && !btn.disabled && label) {
      if (btn.getAttribute('data-cn-orig') == null) btn.setAttribute('data-cn-orig', label.textContent);
      if (label.textContent !== st.button) label.textContent = st.button;
      if (st.note) {
        if (!note && wrap) {
          note = document.createElement('p');
          note.className = 'cn-preorder-note';
          wrap.insertAdjacentElement('afterend', note);
        }
        if (note && note.textContent !== st.note) note.textContent = st.note;
      } else if (note) {
        note.remove();
      }
      setHidden(form, '_cn_preorder', st.line || st.note || '');
      setHidden(form, '_cn_preorder_locale', st.locale);
    } else {
      var orig = btn && btn.getAttribute('data-cn-orig');
      if (btn && orig != null && label) { label.textContent = orig; btn.removeAttribute('data-cn-orig'); }
      if (note) note.remove();
      setHidden(form, '_cn_preorder', null);
      setHidden(form, '_cn_preorder_locale', null);
    }
  }

  var observers = new WeakMap();
  function run() {
    var data = config();
    if (!data) return;
    document.querySelectorAll('product-form').forEach(function (pf) {
      var obs = observers.get(pf);
      if (!obs) {
        obs = new MutationObserver(function () { schedule(pf); });
        observers.set(pf, obs);
      }
      obs.disconnect();
      applyForm(pf, data);
      obs.takeRecords();
      obs.observe(pf, { childList: true, subtree: true, characterData: true });
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 30);
  }

  document.addEventListener('change', function () { setTimeout(schedule, 60); setTimeout(schedule, 500); }, true);
  var tries = 0;
  (function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(schedule, 0); }); } catch (e) { }
      return;
    }
    if (++tries < 50) setTimeout(hook, 100);
  })();
  var lastKey = '';
  setInterval(function () {
    var ids = [];
    document.querySelectorAll('product-form form input[name="id"]').forEach(function (i) { ids.push(i.value); });
    var btn = document.querySelector('product-form .product-form__submit');
    var key = ids.join(',') + '|' + (btn ? btn.disabled : '') + '|' + (document.querySelector('.cn-preorder-note') ? 1 : 0);
    if (key !== lastKey) { lastKey = key; schedule(); }
  }, 600);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
